import React from 'react';
import TimeAgo from 'react-timeago';

import {User} from 'Services';
import {translation} from 'Services/TranslationHelpers';

import ProfilePic from './ProfilePic';
import Chat from './Chat';

export default class SmallChat extends Chat {
    /**
     * @var displayProfilePic
     * @type {boolean}
     */
    displayProfilePic = true;

    /**
     * @var displayTimestamp
     * @type {boolean}
     */
    displayTimestamp = true;

    /**
     * @method render
     * @return {*}
     */
    render() {
        const {selected_chat, chatMaxHeight} = this.props;

        return (
            <div className={`h-full ${chatMaxHeight ?? "max-h-96"}`}>
                {!selected_chat &&
                    <div className="mt-3 p-4 text-center font-bold border-0 text-app-blue">
                        {translation('networking_frontend', 'connect_message')}
                    </div>
                }

                {selected_chat && this.renderSelectedChat()}
            </div>
        )
    }

    /**
     * @method renderSelectedChat
     * @return {*}
     */
    renderSelectedChat() {
        const {new_message} = this.state;
        const {selected_chat} = this.props;

        return (
            <div className='flex h-full flex-col justify-between'>
                {selected_chat.type !== 'App\\Models\\SupportTicket' &&
                    <div className="border-b-2 w-full">
                        <div className="flex px-4 py-3">
                            <div className="my-auto mr-3">
                                <ProfilePic user={selected_chat} />
                            </div>

                            <div>
                                <p className="font-bold text-networking-secondary-text">
                                    {selected_chat.name}
                                </p>

                                {selected_chat.subtitle && selected_chat.subtitle !== '' &&
                                    <p className="mt-2 text-sm">
                                        {selected_chat.subtitle}
                                    </p>
                                }
                            </div>
                        </div>
                    </div>
                }

                {this.renderMessages()}

                <div className="p-4 flex border-t-2 h-36">
                    <input
                        value={new_message}
                        onChange={(e) => this.setState({'new_message': e.target.value})}
                        placeholder={translation('networking_frontend', 'new_message')}
                        onKeyDown={this.handleNewMessageKeyDown}
                        ref={this.newMessageRef}
                        className="bg-networking-secondary border-0 focus:outline-none
                            focus:border-0 focus:ring-0 outline-none w-full px-4"
                    />

                    <button
                        className="w-24 bg-app-orange text-white"
                        onClick={() => this.sendMessage()}
                    >
                        {translation('networking_frontend', 'send_text')}
                    </button>
                </div>
            </div>
        )
    }

    /**
     * @method renderMessage
     * @param {object} message
     * @return {*}
     */
    renderMessage(message) {
        const {selected_chat} = this.props;

        if (!message.user_from_id) {
            return this.renderSystemMessage(message);
        }

        const fromSelf = (User.id === message.user_from_id);

        return (
            <div key={message.id}>
                <div className={`flex ${fromSelf ? 'flex-row-reverse' : ''}`}>
                    <div
                        className={`
                            p-4 m-1 rounded-2xl border w-4/5
                            ${fromSelf ?
                                'bg-networking-active border-networking-active text-networking-primary-text rounded-br-none' :
                                'bg-networking-secondary border-networking-secondary text-networking-secondary-text rounded-bl-none'}
                        `}
                    >
                        <p>
                            {message.message}
                        </p>

                        <div className="flex flex-row justify-between w-full mt-2">
                            <div className="text-xs text-app-blue">
                                {this.displayTimestamp && <TimeAgo date={message.created_at.iso_string}/>}
                            </div>

                            <div className="text-xs">
                                {message.message_to_type !== "App\\Models\\User" && !fromSelf && message.user_from.name}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
